module.exports = __webpack_public_path__ + "static/media/mail.def8c516.svg";